<template>
  <div class="datalist-container">
    <div class="list-head-container">
      <div class="head-left"><h1>{{ title }}</h1></div>
      <div class="head-right">
        <div :class="( isDark ? 'dark' : '' )" class="search-container">
          <input :class="( isDark ? 'dark' : '' )" @click="collapseLast" v-model="search"  placeholder="Search" type="text" name="search" id="search"/>
          <div class="search-icon"></div>
        </div>
        <div :class="( isDark ? 'dark' : '' )" class="filter-button">
          <div class="order-icon"></div>
          <select :class="( isDark ? 'dark' : '' )" class="filter-button" @change="updateSearchFilter" name="search-filter" id="search-filter">
              <option value="project">Search by project</option>
              <!-- <option value="name">Search by name</option> -->
              <option value="title">Search by title</option>
              <option value="client">Search by client</option>
              <option value="latestMonth">Search by latest month</option>
              <option value="percentHours">Search by percent hours</option>
            </select>
        </div>
        <div @click="exportDB('project_staffings')" class="export-button"><div class="export-icon"></div>{{ ( isExporting ? 'Exporting...' : 'Export' ) }}</div>
      </div>
    </div>

    <div :class="( isDark ? 'dark border-dark' : '' )" class="list-top" :style="(!filteredItems.length == 0  ? 'opacity: 1' : 'opacity: 0' )">
      <div class="col pre-col"><span>#</span></div>
      <div v-for="(column, index) in columnTitles" :key="index" class="col"><span>{{ column }}</span></div>
      <div class="col pre-col"><span class="hint-button"><div class="hint-box">This field shows the percentage of time the individual listed has accounted for out of the total hours logged for that project in the last six months. For example, if there were 100 hours logged on that project in the last six months and someone logged 35 - this would display as 35%. It is not a reflection of their total amount of hours.</div></span></div>
    </div>

    <div class="list-contents-container" id="scrollable-inner">
      <div :class="( isDark ? 'dark' : '' )" class="services-container">
        <div class="services-container-right">
          <ul>
            <li v-if="filteredItems.length == 0" class="no-results"><h4 style="text-align: center; margin-top: 200px">No Results</h4></li>
            <li 
            class="list-item"
            :style="'background:'+( index1 % 2 == 0 ? ( isDark ? '#1b1b1b' : '#f9f9f9') : ( isDark ? '#1f1f1f' : '#ffffff') )"
            v-for="(i, index1) in filteredItems" 
            v-bind:key="index1" 
            :id="i.email"
            :class="(index1 != 0 ? '' : 'first-service')">
              <div :id="'item'+index1" @click="dropdown" class="inner-columns-container">
                <div class="pre-key-col"><span>{{ index1+1 }}</span></div>
                <div v-for="(colKey, index2) in columnKeys" :key="index2" class="key-col">
                  <span :class="( index2 == columnKeys.length - 1 ? 'cozy' : '')">
                    {{ filteredItems[index1][colKey] }}<span v-if="index2 == columnKeys.length - 1" class="percent"></span>
                  </span>
                  <ProgressBar v-if="graphable && index2 == columnKeys.length - 1" :value="parseInt(filteredItems[index1].truePercent)" />
                </div>
              </div>
            </li>.
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue';
import { dbUtils } from '../mixins/dbUtils';
import store from '../store';

export default {
  name: 'DataList',
  components: {
    ProgressBar
  },
  mixins: [dbUtils],
  props: {
    title: {
      type: String,
      default: 'List Title'
    },
    test: {
      type: Boolean,
      default: false
    },
    expandable: {
      type: Boolean,
      default: false
    },
    data: Array,
    columnTitles: Array,
    columnKeys: Array,
    graphable: Boolean
  },
  data() {
    return {
      droppable: [],
      items: [],
      search: '',
      activeDrop: null,
      lastDropped: null,
      dropActive: false,
      currentStudent: null,
      searchFilter: 'project',
      newTag: null
    }
  },
  mounted() {
      setTimeout(() => {
          console.log('data: ', this.data);
      }, 3000);
  },
  computed: {
    filteredItems() {
        var filteredData = this.data.filter((item) => {
            return item[this.searchFilter].toLowerCase().match(this.search.toLowerCase());
        });

        console.clear();
        return this.sortResults(filteredData, this.searchFilter, true);
    },
    isExporting() {
        return store.state.isExporting;
    },
    isDark() {
        return store.state.dark;
    }
  },
  methods: {
    handleExport() {
      this.$emit('exportList');
    },
    dropdown(event) {
      this.currentStudent = event.currentTarget.childNodes[3].childNodes[0].childNodes[1].textContent;

      var currentDroppable = event.currentTarget.nextSibling;
      //on first drop
      !this.lastDropped || currentDroppable.classList.contains('dropped') ? console.log('hang time') : this.lastDropped.classList.remove('dropped');
      //drop toggle
      currentDroppable.classList.contains('dropped') ? currentDroppable.classList.remove('dropped') : currentDroppable.classList.add('dropped');
      if(this.lastDropped == currentDroppable) {
        this.dropActive = !this.dropActive;
      } else {
        this.dropActive = false;
        setTimeout(() => {
          this.dropActive = true;
        }, 100);
      }
      //queue last dropped
      this.lastDropped = currentDroppable;
      this.$forceUpdate();
    },
    collapseLast() {
      !this.lastDropped ? console.log('nothing to collapse') : this.lastDropped.classList.remove('dropped');
    },
    updateSearchFilter(e) {
      this.searchFilter = e.target.value;
    },
    sortResults(data, prop, asc) {
        data.sort((a, b) => {
            if(prop == 'percentHours') {
                if (asc) {
                    return (parseInt(this.numify(a[prop])) > parseInt(this.numify(b[prop]))) ? 1 : ((parseInt(this.numify(a[prop])) < parseInt(this.numify(b[prop]))) ? -1 : 0);
                } else {
                    return (parseInt(this.numify(b[prop])) > parseInt(this.numify(a[prop]))) ? 1 : ((parseInt(this.numify(b[prop])) < parseInt(this.numify(a[prop]))) ? -1 : 0);
                }
            } if(prop == 'client') {
                prop = 'project';
                if (asc) {
                    return (a[prop] > b[prop]) ? 1 : ((a[prop] < b[prop]) ? -1 : 0);
                } else {
                    return (b[prop] > a[prop]) ? 1 : ((b[prop] < a[prop]) ? -1 : 0);
                }
            } else {
                if (asc) {
                    return (a[prop] > b[prop]) ? 1 : ((a[prop] < b[prop]) ? -1 : 0);
                } else {
                    return (b[prop] > a[prop]) ? 1 : ((b[prop] < a[prop]) ? -1 : 0);
                }
            }
        });
        console.log(data);
        return data;
    },
    numify(input) {
        return input.substring(0, input.length-1);
    }
  }
}
</script>

<style scoped lang="scss">

.hint-button {
    width: 24px;
    height: 24px;
    transform: translateX(-48px);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('https://raw.githubusercontent.com/tbrew1023/icommon/62ee0d42d708c9ff90a686f5c6c8061d0868bc97/info-24px.svg');

    .hint-box {
        opacity: 0;
        background: black;
        width: 240px;
        color: white;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 32px;
        margin-left: -112px;
        backdrop-filter: blur(24px);
        transform: translateY(-6px);
        transition: 300ms;
        pointer-events: none;
        padding: 18px;
        text-align: center;
        text-transform: none;
    }

    &:hover {
        .hint-box {
            opacity: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            transform: translateY(0px);
        }
    }
}

.dark {
    background: #1b1b1b !important;
    
    .search-icon {
        filter: invert(1) !important;
    }
}

.border-dark {
    border-bottom: black 1px solid !important;
}

.test-scores-container {
    //width: max-content !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;

    strong {
        margin: 0px 32px 0px 0px !important;
    }

    b {
        margin-left: 0px 12px 24px 12px !important;
        display: flex;
        align-items: center;
    }
}

.tags-container {
    display: flex;
    text-align: center;
    justify-content: center;
}

.pill {
    //background: #ddd;
    border-radius: 12px;
    padding: 0px;
    margin: 0px 3px 0px 3px !important;
}

.profile-photo {
    background: #e0e0e0;
    height: 36px;
    width: 36px;
    border-radius: 100%;
    margin-right: 24px;
    margin-left: -18px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.cozy {
    //background: red;
    width: 70px !important;
}

.percent {
    margin: 0px !important;
}

.disabled {
    background: rgba(black,0.1) !important;
    color: rgba(black, 0.2) !important;
    cursor: not-allowed !important;
    pointer-events: none;
}

.droppable-actions-container {
  display: flex;
  margin-left: 18px;
}

.remove-student-btn {
  background: rgba(red, 0.1);
  color: red;
  padding: 6px 12px;
  border-radius: 8px;
  margin-right: 18px;
  animation: flyin 200ms ease forwards 300ms;
  cursor: pointer;
  transition: 200ms !important;
  opacity: 0;
  transform: scale(0.6);
  pointer-events: all;

  &:hover {
    background: rgba(red, 0.5);
    color: white;
  }
}

.drop-btn1 {
  opacity: 0;
  transform: scale(0.6);
  animation: flyin 200ms ease forwards 100ms;
  margin-right: 12px;

  input {
    padding: 8px 8px 8px 12px;
    border: none;
    border-radius: 8px;
    width: 200px;

    &:focus {
      outline: none;
    }
  }
}

.drop-btn2 {
  opacity: 0;
  transform: scale(0.6);
  animation: flyin 200ms ease forwards 200ms;
  transition: 200ms !important;
}

@keyframes flyin {
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.inner-columns-container {
  display: flex;
  width: 100%;
  flex-basis: auto;
  height: inherit;
  cursor: default;
}

.add-icon {
  //background-size: 70%;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("https://raw.githubusercontent.com/tbrew1023/icommon/c8e31784a53239d9469dc8625b184adbf7b941e3/blue-plus.svg");
  height: 24px;
  width: 24px;
  //margin-left: -36px;
}

.search-icon {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("https://raw.githubusercontent.com/tbrew1023/icommon/c5bf1076cb9bf0a5f060b81624b53f01b4953a71/search.svg");
  opacity: 0.2;
  height: 24px;
  width: 24px;
  margin-left: -36px;
}

.head-left {
  display: flex;
  align-items: center;

  h1 {
    font-size: 24px;
    font-weight: bold;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 12px;
  }
}

.head-right {
  display: flex;
  height: 40px;
}

.list-head-container {
  height: 36px;
  //background: red;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list-contents-container {
  height: 75%;
  overflow: auto;
  border-radius: 0px 0px 8px 8px;
}

.key-col {
  //border: 1px black solid;
  width: 100%;
  height: inherit;
  display: flex;
  align-items: center;
  padding: 24px 0px 24px 0px;
  color: black;
  justify-content: flex-start;

  span {
    font-size: 12px;
    opacity: 1;
    text-align: left;
    margin-left: 36px;
  }
}

.pre-col, .pre-key-col {
  //border: 1px black solid;
  width: 20% !important;
  height: inherit;
  display: flex;
  justify-content: left;
  align-items: center;

  span {
    margin-left: 32px;
    font-size: 12px;
    text-transform: uppercase;
    opacity: 0.4;
  }  
}

.col {
  //border: 1px black solid;
  width: 100%;
  height: inherit;
  display: flex;
  justify-content: left;
  align-items: center;

  span {
    margin-left: 24px;
    font-size: 12px;
    text-transform: uppercase;
    opacity: 0.4;
  }
}

.list-top {
  background: white;
  width: 100%;
  height: 63px;
  margin-top: 24px;
  border-radius: 8px 8px 0px 0px;
  border-bottom: #eee 1px solid;
  display: flex;
  align-items: center;
  //box-shadow: 0px 36px 36px -24px black;
}

.no-results {
  margin-top: 120px;
  font-size: 14px;
  text-align: center;
}

.search-container {
  display: flex;
  background: transparent;
  //border-radius: 12px;
  width: auto;
  //background: green;
  align-items: center;
  justify-content: center;
  margin-right: 24px;

  #search {
    width: 500px;
    border: none;
    padding: 12px 0px 12px 24px;
    text-align: left;
    border-radius: 8px;
    font-size: 14px;
    margin: 0px !important;
    
    &:focus {
      outline: none;
    }
  }
}

.add-button {
  width: 72px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.export-button {
  background: rgba(70,113,177,0.3) !important;
  width: 96px !important;
  margin-right: 0px !important;
  margin-top: 0px !important;
}

.filter-button {
  transform: scale(1) !important;
  width: max-content !important;
  outline-style: none;
  box-shadow: none;
  border-color: transparent;
}

.filter-button, .export-button, .add-button {
  font-weight: bold;
  background: white;
  border-radius: 8px;
  height: 36px;
  width: 160px;
  padding: 3px 6px;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 200ms;
  cursor: pointer;
  color: black;
  margin-left: 12px;
  font-size: 12px;
  color: #4671B1;

  .export-icon {
    background-image: url('https://github.com/tbrew1023/icommon/blob/master/blue-export.png?raw=true');
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
    width: 18px;
    height: 18px;
    margin-right: 6px;
  }

  .order-icon {
    background-image: url('https://raw.githubusercontent.com/tbrew1023/icommon/c8e31784a53239d9469dc8625b184adbf7b941e3/blue-filter.svg');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 18px;
    height: 18px;
    margin-right: -12px;
    margin-left: 12px;
  }

  &:hover {
    transform: scale(0.95);
  }
}

.list-item {
  display: block !important;
  background: #f9f9f9;
  margin: 0px;
}

#item1 {
  border: none !important;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  //display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.datalist-container {
  width: 100%;
  height: 100%;
  margin-top: 48px;
}

.services-container {
    overflow: auto;
    height: 420px;
    background: rgba(white, 0.3);

  .service-icon {
    //background: black;
    //opacity: 0.2;
    display: none;
    height: 32px;
    width: 32px;
    margin-right: 24px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  ul {
    margin: 0px;
    padding: 0px;
    list-style: none;

    .droppable {
      width: 100%;
      height: 0px !important;
      color: black !important;
      transition: 300ms;
      text-align: left;
      padding-top: 0px;
      margin: 0px;
      opacity: 0;
      flex-direction: column;
      z-index: -1;
      pointer-events: none;

      strong {
        margin-top: 6px;
        display: none;
        text-align: center
      }

      .bottom-droppable {
        //display: none !important;
        //background: red;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .remove-student-btn {
          display: none;
        }

        .droppable-btn {
          background: #4671B1;
          height: 30px;
          width: 100px;
          margin-right: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          border-radius: 8px;
          cursor: pointer;
          transition: 200ms !important;

          &:hover {
            background: rgba(#4671B1,0.3);
            color: #4671B1;
          }
        }
      }
    }

    .dropped {
      background: #e9e9e9 !important;
      height: 100px !important;
      transition: 300ms;
      opacity: 1 !important;
      padding-top: 12px;
      pointer-events: all;
      display: flex;
      margin: 0px;

      .remove-student-btn {
        display: block !important;

        &:hover {
          transform: scale(0.95);
        }
      }

      strong {
        text-align: center;
        display: block;
      }
      
      span {
        margin-left: 24px;
      }
    }
    
    li {
      //border: 1px solid black;
      //border-top: 1px #e0e0e0 solid;
      //display: flex;
      //justify-content: center;
      //align-items: center;

      span {
        //color: red;
        font-size: 14px;
        //text-transform: uppercase;
        //font-weight: bold;
        //width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        transition: 100ms;

        b {
          margin-right: 24px;
          height: 12px;
          width: 12px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          //background-image: url('https://github.com/tbrew1023/icommon/blob/master/arrow-down.png?raw=true');
        }
      }

      &:hover {
        span {
          b {
            color: black !important;
          }
        }
      }
    }
  }

  .service-par {
    font-size: 14px;
  }

  h1 {
    font-size: 52px;
    font-weight: bold;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  p {
    width: 85%;
  }

}

.right {
  transform: rotate(180deg);
  transition: 300ms;
}

.up {
  transform: rotate(0deg);
  transition: 300ms;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track { 
  border-radius: 0px 0px 8px 0px;
  background: transparent;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #e0e0e0; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  //background: #gray; 
}
</style>
